(ns frontend.ui.component.text-input.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer
    [border-radius border-width color edge-size text-size]]
   [garden.util :refer [space-join]]))

(defn text-input
  []
  (with-meta
    {:width         "100%"
     :padding       (space-join [(edge-size :xsmall)
                                 (edge-size :small)])
     :font-size     (text-size :small :size)
     :font-family   "inherit"
     :border-radius (border-radius :xxxsmall)
     :border        (space-join ["1px"
                                 "solid"
                                 (theme/color [:text-input :border :regular])])}
    {:pseudo
     {:hover
      {:outline "none"
       :border  (space-join [(border-width :medium)
                             "solid"
                             (theme/color [:text-input :border :hover])])}
      :focus
      {:outline "none"
       :border  (space-join [(border-width :medium)
                             "solid"
                             (theme/color [:text-input :border :focus])])}}}))
